<script lang="ts">
import type GiftTag from '@consumer/types/GiftTag'
import type AdminConsumerTypeaheadSelect from '@admin/types/serializers/Admin/Consumer/TypeaheadSelect'
export type TagSelectOption = AdminConsumerTypeaheadSelect & GiftTag
</script>
<script setup lang="ts">import { computed as _computed } from 'vue';

import { uniqBy } from 'lodash-es'
import { giftTags } from '@consumer/api'

withDefaults(defineProps<{
  tagType: GiftTag['tagType']
  allTags: AdminConsumerTypeaheadSelect[]
  modelValue: AdminConsumerTypeaheadSelect[]
  popular?: AdminConsumerTypeaheadSelect[]
  name?: string
}>(), { popular: () => ([]), })
const emit = defineEmits<{
  'update:modelValue': [TagSelectOption[]]
}>()
const options = _computed(() => [...__props.allTags, ...__props.modelValue])

const popularWithoutSelected = _computed(() => {
  return __props.popular.filter(tag => !__props.modelValue.some(selected => selected.value === tag.value))
})

function onUpdateModelValue (value: TagSelectOption[]) {
  emit('update:modelValue', uniqBy(value.map((tag) => {
    let id: any
    if (typeof tag.value === 'number') {
      id = tag.value
    }
    return {
      ...tag,
      id,
      tag: tag.label,
      tagType: tag.tagType || __props.tagType,
    }
  }), 'tag'))
}
</script>

<template>
  <GSelectInput
    :modelValue="modelValue"
    :options="options"
    :emptyQueryOptions="popularWithoutSelected"
    :fetchOptions="giftTags.search"
    :name="name"
    allowCreate
    wholeItem
    multi
    :data-multi-select-for="name"
    @update:modelValue="onUpdateModelValue"
  >
    <template #itemPost="{ item }">
      <span
        v-if="item.tagType !== tagType"
        class="ml-2 text-xs italic text-gray-500"
      >
        {{ item.tagType }}
      </span>
    </template>
  </GSelectInput>
</template>
